import { Checkbox } from "@material-ui/core";
import styles from "../createGame.module.css";
import { translate } from "../../../../translations/index.ts";

export default function StatementsStep({ template, setTemplate, statements }) {
  const toggleAll = () => {
    const newList =
      template.statements.length > 0 ? [] : statements.map((s) => s._id);
    setTemplate({ ...template, statements: newList });
  };

  const selectStatement = (statement) => {
    let newList = [...template.statements];
    if (newList.includes(statement._id)) {
      newList = newList.filter((id) => id !== statement._id);
    } else {
      newList.push(statement._id);
    }
    setTemplate({ ...template, statements: newList });
  };

  return (
    <>
      <h3 className={styles.stepTitle}>
        {translate("teacher.gameSettings.steps.statements.label")}
      </h3>

      <div className={styles.allStatementsContainer}>
        <Checkbox
          id="statements-toggle-all"
          checked={template.statements.length === statements.length}
          onChange={toggleAll}
        />
        <label htmlFor="statements-toggle-all">
          {translate("teacher.gameSettings.steps.statements.all")}
        </label>
      </div>
      <div className={styles.optionsContainer}>
        {statements.map((statement, index) => (
          <div className={styles.optionContainer} key={index}>
            <Checkbox
              value={statement._id}
              id={`statement-${statement._id}`}
              checked={template.statements.includes(statement._id)}
              onChange={() => selectStatement(statement)}
            />
            <label htmlFor={`statement-${statement._id}`}>
              {statement.description}
            </label>
          </div>
        ))}
      </div>
    </>
  );
}
